import { formatDate } from "@angular/common";
import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "mydate",
})
export class datePipe implements PipeTransform {
  transform(value: any, format: string): any {
    if (!value) {
      return "";
    }
    if (!format) {
      format = "dd/MM/yy";
    }
    return formatDate(value, format, "en-US");
  }
}
